import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AppointmentService } from './appointment/appointment.service';
import { ApplicationService } from './application/application.service';
import { ScriptService } from './script/script.service';
import { TokenExchangeService } from './token-exchange.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private authService: MsalService,
    private appointmentService: AppointmentService,
    private appService: ApplicationService,
    private scriptService: ScriptService,
    private tokenExchangeService: TokenExchangeService
  ) {}

  /**
   * Perform logout by clearing local state and triggering MSAL logout
   */
  logout(): void {
    // Clear local state before logging out
    this.appointmentService.Clear();
    this.appService.Clear();
    this.scriptService.Clear();
    this.tokenExchangeService.clearProxyToken();
    // Redirect to the MSAL logout endpoint which will then redirect to postLogoutRedirectUri
    this.authService.logoutRedirect();
  }
}
